import { CSSProperties, useEffect, useState } from "react";
import { getCookie } from "cookies-next";
import { useConsentStore } from "./consentStore";
import { ConsentCategory } from "./constants";
import {
  COUNTRY_COOKIE_NAME,
  isGdprCountry,
  isNoBannerCountry,
} from "./gdprRegions";

const overlayStyle: CSSProperties = {
  position: "fixed",
  right: 8,
  top: 8,
  zIndex: 99999,
  background: "rgba(0,0,0,0.85)",
  color: "#0f0",
  font: "11px/1.4 ui-monospace, monospace",
  padding: 10,
  borderRadius: 6,
  maxWidth: 360,
};

// ?consent-debug=1 로 활성화되는 진단 오버레이.
// 지역/GPC/저장 consent/store 상태를 한눈에 보여줌. production에서는 자동 비활성.
// CS 티켓 재현 시: 유저에게 URL ?consent-debug=1 붙여서 스크린샷 요청하면 전 상태 파악 가능.
export function ConsentDebug() {
  const [enabled, setEnabled] = useState(false);
  const consent = useConsentStore((s) => s.consent);
  const hasConsented = useConsentStore((s) => s.hasConsented);
  const initialized = useConsentStore((s) => s.initialized);
  const showBanner = useConsentStore((s) => s.showBanner);
  const showDeclineButton = useConsentStore((s) => s.showDeclineButton);

  useEffect(() => {
    if (process.env.NEXT_PUBLIC_ENV === "production") return;
    const params = new URLSearchParams(window.location.search);
    // URL 쿼리(?consent-debug=1)는 마운트 후에만 읽을 수 있는 외부 상태이고,
    // 서버 렌더와의 hydration mismatch를 피하려면 effect에서 세팅해야 한다
    // (set-state-in-effect 규칙의 정당한 예외 — 외부 시스템 동기화).
    // eslint-disable-next-line react-hooks/set-state-in-effect
    if (params.get("consent-debug") === "1") setEnabled(true);
  }, []);

  if (!enabled) return null;

  const country = (getCookie(COUNTRY_COOKIE_NAME) as string | undefined) || "∅";
  const gpc =
    typeof navigator !== "undefined" &&
    (navigator as Navigator).globalPrivacyControl === true;

  const rows: Array<[string, string]> = [
    ["country (bhap_country)", country],
    [
      "isGdprCountry()",
      String(isGdprCountry(country === "∅" ? null : country)),
    ],
    [
      "isNoBannerCountry()",
      String(isNoBannerCountry(country === "∅" ? null : country)),
    ],
    ["navigator.globalPrivacyControl", String(gpc)],
    ["store.initialized", String(initialized)],
    ["store.hasConsented", String(hasConsented)],
    ["store.showBanner", String(showBanner)],
    ["store.showDeclineButton", String(showDeclineButton)],
    ["consent.Performance", String(consent[ConsentCategory.Performance])],
    ["consent.Advertising", String(consent[ConsentCategory.Advertising])],
  ];

  return (
    <div style={overlayStyle}>
      <div style={{ color: "#fff", marginBottom: 4, fontWeight: 600 }}>
        consent debug
      </div>
      <table>
        <tbody>
          {rows.map(([k, v]) => (
            <tr key={k}>
              <td style={{ opacity: 0.7, paddingRight: 8 }}>{k}</td>
              <td>{v}</td>
            </tr>
          ))}
        </tbody>
      </table>
      <div style={{ opacity: 0.5, marginTop: 4 }}>
        clear: document.cookie = &quot;bhap_country=; max-age=0; path=/&quot;
      </div>
    </div>
  );
}
